import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { SessionsProvider } from '../providers/sessions-provider';
import { Session } from "../../common/models/session";
import { Observable, of, throwError } from "rxjs";
import { error } from "@angular/compiler-cli/src/transformers/util";
import { catchError } from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class SessionResolver implements Resolve<Session> {
    constructor(
        private sessionProvider: SessionsProvider,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
      const sessionId: number = route.params['sessionId'];
      if (isNaN(sessionId) || sessionId <= 0) return of({});
      return this.sessionProvider.getSession({id: sessionId, filled: true}).pipe(
        catchError(error => {
          if (error.status === 404) {
            return of({});
          } else {
            return throwError(error);
          }
        })
      );
    }
}
